// Shared text sanitizer for visitor / Q&A content.
// Strips control chars, normalizes line endings, caps blank lines/lines/length,
// and breaks unbroken character runs so text wraps inside fixed-width containers.

export const MAX_MESSAGE_CHARS = 4000;
export const MAX_MESSAGE_LINES = 80;
export const MAX_RUN_LENGTH = 80;

export function sanitizeMessage(raw: unknown): { text: string; truncated: boolean } {
  if (raw == null) return { text: "", truncated: false };
  let text = String(raw);
  text = text.replace(/[\u0000-\u0008\u000B-\u001F\u007F]/g, "");
  text = text.replace(/\r\n?/g, "\n");
  text = text.replace(/\n{4,}/g, "\n\n\n");
  const lines = text.split("\n");
  let truncated = false;
  if (lines.length > MAX_MESSAGE_LINES) {
    text = lines.slice(0, MAX_MESSAGE_LINES).join("\n");
    truncated = true;
  }
  text = text.replace(new RegExp(`(\\S{${MAX_RUN_LENGTH}})`, "g"), "$1\u200B");
  if (text.length > MAX_MESSAGE_CHARS) {
    text = text.slice(0, MAX_MESSAGE_CHARS);
    truncated = true;
  }
  return { text, truncated };
}
